module.exports = __webpack_public_path__ + "img/no-bg.b1dc8c7c.png";